import { DomainsClient } from '@/core/api/domains-client'
import {
    DomainInfoResponseData,
    DomainOperationRequest,
    DomainParameters,
} from '@atbay/domains-manager-node-sdk'
import { BaseService } from '@core/base/service/base-service'

const getDomainsWithoutDuplications = (domains: DomainInfoResponseData[]) => {
    // If a domain exists as both 'UserApproved' and Policy/MDR, prefer the
    // Policy/MDR entry — those can't be removed by the user, so they take precedence.
    const domainsMap = domains.reduce((acc, domain) => {
        const isDomainExists = acc.get(domain.domain_url)
        if (
            !isDomainExists ||
            domain.status === 'Policy' ||
            domain.status === 'MDR'
        ) {
            acc.set(domain.domain_url, domain)
        }
        return acc
    }, new Map<string | undefined, DomainInfoResponseData>())
    return [...domainsMap.values()]
}


export const DomainsService = new (class DomainsService extends BaseService {
    private readonly client = DomainsClient

    constructor() {
        super('domains.service')
    }

    async getAccountDomains() {
        const [error, result] = await this.request(() =>
            this.client.getAccountDomains(this.accountId, 'all')
        )
        if (error) {
            return undefined
        }
        const domains = result?.data?.data?.domains || []

        return getDomainsWithoutDuplications(domains)
    }

    async validateDomain(
        domain: string
    ): Promise<[string, boolean] | [undefined, boolean]> {
        const [_, res] = await this.request(() =>
            this.client.handleValidateDomain(this.accountId, {
                domain_url: domain,
            })
        )

        // @ts-ignore
        const error = res?.data.data?.message
        if (!!error) {
            return [error, false]
        }
        return [undefined, true]
    }

    async addDomains(domains: DomainParameters[]): Promise<boolean> {
        const [error] = await this.request(() =>
            this.client.handleAccountDomainOperation(this.accountId, {
                domains,
                action: DomainOperationRequest.action.ADDED,
            })
        )

        if (error) {
            console.log('error', error)
            return false
        }
        return true
    }
})()
